<div class="row">
  <div class="col-md-12">
    <div *ngIf="config('card_annonces')?._view" class="card">
      <div *ngIf="config('txt_card_annonces')?._view" [style]="safeCss(config('cards_colors')?.style)" [class]="config('title_home1')?.class ? 'card-header ' + config('title_home1')?.class : 'card-header'">
        <h2 [class]="config('txt_card_annonces')?.param1 ? 'card-title ' + config('txt_card_annonces')?.param1 : ''">
          {{ config('txt_card_annonces')?.txt }}
        </h2>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <mat-form-field [color]="param.color">
              <mat-label>Recherche</mat-label>
              <input matInput [(ngModel)]="filter" (keyup)="applyFilter()" placeholder="Ex. Paris">
            </mat-form-field>
          </div>
          <div class="col-md-6 col-xs-12">
            <mat-form-field [color]="param.color">
              <mat-select panelClass="example-panel-{{param.color}}" multiple [formControl]="toppingsRegions" placeholder="Choisir une localisation..." (selectionChange)="applyFilter()">
                <ng-container *ngFor="let fruit of regions">
                  <mat-option [value]="fruit.region">
                    {{ fruit.region }} ({{countRegions(fruit.region)}})
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <mat-form-field [color]="param.color">
              <mat-select panelClass="example-panel-{{param.color}}" multiple [formControl]="toppings" placeholder="Contrats" (selectionChange)="applyFilter()">
                <ng-container *ngFor="let contrat of posteContrat">
                  <mat-option [value]="contrat.contrat">
                    {{ contrat.contrat }} ({{countContrats(contrat.contrat)}})
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-xs-12">
            <mat-form-field [color]="param.color">
              <mat-select panelClass="example-panel-{{param.color}}" multiple [formControl]="toppingsFonc" placeholder="Fonctions" (selectionChange)="applyFilter()">
                <ng-container *ngFor="let fonction of emploiFonction">
                  <mat-option [value]="fonction.fonction">
                    {{ fonction.fonction }} ({{countFonctions(fonction.fonction)}})
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!--<div class="col-md-6 col-xs-12">
            <mat-form-field [color]="param.color">
              <mat-select panelClass="example-panel-{{param.color}}" multiple [formControl]="toppingsSocs" placeholder="Sociétés" (selectionChange)="applyFilter()">
                <ng-container *ngFor="let soc of getSocietes()">
                  <mat-option *ngIf="countSocs(soc) > 0" [value]="soc">
                    {{ soc }} ({{countSocs(soc)}})
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>-->
        </div>
        <mat-paginator *ngIf="annoncesFilter && annoncesFilter.length > 0" class="col-md-12"
                       [length]="length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       (page)="pageEvent = $event"
                       [color]="param.color">
        </mat-paginator>
        <div style="margin-top: 2em;" *ngIf="isLoading" class="col-md-6 offset-md-3 text-center">
          <span class="center">Récupération des offres en cours</span>
          <mat-card style="display: flex; justify-content: center; align-items: center">
            <mat-progress-bar color="accent" mode="indeterminate">
            </mat-progress-bar>
          </mat-card>
        </div>
        <div style="margin-top: 2em;" class="col-md-12 text-center" *ngIf="(!annoncesFilter || annoncesFilter.length <= 0) && !isLoading">
          <h3><b>Aucune offre trouvée.</b></h3>
          Nous vous invitons à effectuer une nouvelle recherche ou à déposer votre dossier de <a class="text-rose" routerLink="../inscription">candidature spontanée</a>.
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row equal" *ngIf="annoncesFilter">

  <div style="margin-bottom: 1rem;" [className]="mono ? 'col-md-12' : 'col-md-4'" *ngFor="let annonce of annoncesFilter.slice(pageEvent ? (pageEvent.pageIndex * pageEvent.pageSize) : (0), pageEvent ? (pageEvent.pageIndex * pageEvent.pageSize + pageEvent.pageSize) : (12))">
    <div *ngIf="annonce.societe_groupe==='Aquasplash'">
      <a href="" (click)="goToAnnonce(annonce.idannonce)">

        <mat-card class="example-card">
          <mat-card-header>

            <div [style]="safeCss(config('annonces_card')?.style + 'background-size: cover;background-image:url(' + annonce.societe_logo + ');')" *ngIf="annonce.societe_logo?.substr(0, 2) !== 'fa'" mat-card-avatar></div>
            <div [style]="safeCss(config('annonces_card')?.style)" mat-card-avatar *ngIf="annonce.societe_logo?.substr(0, 2) === 'fa'"><i [class]="annonce.societe_logo"></i></div>
            <mat-card-title>{{ annonce.intitule | uppercase}}</mat-card-title>

          </mat-card-header>
          <mat-card-content [innerHtml]="lowText(annonce.caract_poste, 200)">
          </mat-card-content>

          <mat-card-actions style="position: absolute;bottom: 0;">
            <p>
              {{ annonce.code_postal }} {{ annonce.ville }} ● {{ lowText(annonce.regions, 20) }} ● {{ annonce.contrats }}
            </p>
          </mat-card-actions>

        </mat-card>
      </a>
    </div>
  </div>
</div>
